<template>
  <div class="articleDetail">
    <div class="crumbs">
      <div class="container">
        <div>
          <router-link :to="navData.path" class="link">
            {{ navData.text }}
          </router-link>
          > {{ detail }}
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="container">
        <div class="article">
          <div class="title">{{ title }}</div>
          <div class="infos">
            <span style="margin-right: 15px"
              >发布时间：{{ updateTime | FormatDate }}</span
            >
            <span>发布人：{{ publisher }}</span>
          </div>
          <div v-html="article" class="ql-editor"></div>
          <div
            class="attachments"
            style="margin-top: 20px"
            v-if="cmsFiles.length"
          >
            <div style="margin-bottom: 15px">附件：</div>
            <p style="line-height: 25px">
              <a
                :href="'https://minio.akbigdata.cn/' + file.path"
                v-for="file in cmsFiles"
                :key="file.id"
                :download="file.name"
                >{{ file.name }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getArticleDetail } from "@/api";
import "@/assets/css/quill-better-table.css";
import "@/assets/css/quill.snow.css";
export default {
  name: "articleDetail",
  data() {
    return {
      title: "",
      updateTime: "",
      publisher: "",
      article: "",
      detail: "新闻详情",
      cmsFiles: [],
      navData: this.utils.navMap[this.$route.params.parent],
    };
  },
  async mounted() {
    let data = await getArticleDetail(this.$route.params.id);
    this.article = data.data.data.content;
    this.title = data.data.data.title;
    this.publisher = data.data.data.publisher;
    this.updateTime = data.data.data.updateTime;
    this.cmsFiles = data.data.data.cmsFiles;
    if (this.navData.text == "项目展示") {
      this.detail = "项目详情";
    }
    // 存入一个搜索标识
    sessionStorage.setItem("searchFlag", true);
  },
};
</script>
<style scoped>
.crumbs {
  height: 50px;
  line-height: 50px;
  color: #333;
  font-size: 14px;
  border-bottom: solid 1px #d6d6d6;
  margin-bottom: 30px;
}
.crumbs .link {
  color: #8d8d8d;
}
.title {
  text-align: center;
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 20px;
  line-height: 30px;
}
.infos {
  color: #888;
  font-size: 15px;
  border-bottom: 1px solid #eee;
  line-height: 35px;
}
.articleDetail {
  padding-bottom: 80px;
}
</style>
